/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Stats_PlatinumInputs */

const id_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platinum`)
};

const ms_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platinum`)
};

const da_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platinum`)
};

const de_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Platin`)
};

const en_us2_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platinum`)
};

const es_es2_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platino`)
};

const es_mx2_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platino`)
};

const fil_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platinum`)
};

const fr_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platine`)
};

const it_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platino`)
};

const hu_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platina`)
};

const nl_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platina`)
};

const no_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platinum`)
};

const pl_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platyn`)
};

const pt_br2_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platina`)
};

const pt_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platinas`)
};

const ro_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platină`)
};

const fi_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platinaa`)
};

const sv_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platina`)
};

const vi_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} bạch kim`)
};

const tr_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platin`)
};

const cs_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} platin`)
};

const bg_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} платина`)
};

const ru_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} платин`)
};

const uk_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} платина`)
};

const ar_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} بلاتين`)
};

const hi_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} प्लैटिनम`)
};

const th_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} แพลตตินัม`)
};

const ja_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} プラチナ`)
};

const zh_cn2_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 项白金`)
};

const zh_hant1_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 項白金`)
};

const ko_profile_stats_platinum = /** @type {(inputs: Profile_Stats_PlatinumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`플래티넘 ${i?.count}개`)
};

/**
* | output |
* | --- |
* | "{count} platinum" |
*
* @param {Profile_Stats_PlatinumInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_stats_platinum = /** @type {((inputs: Profile_Stats_PlatinumInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Stats_PlatinumInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_stats_platinum(inputs)
	if (locale === "ms") return ms_profile_stats_platinum(inputs)
	if (locale === "da") return da_profile_stats_platinum(inputs)
	if (locale === "de") return de_profile_stats_platinum(inputs)
	if (locale === "en-US") return en_us2_profile_stats_platinum(inputs)
	if (locale === "es-ES") return es_es2_profile_stats_platinum(inputs)
	if (locale === "es-MX") return es_mx2_profile_stats_platinum(inputs)
	if (locale === "fil") return fil_profile_stats_platinum(inputs)
	if (locale === "fr") return fr_profile_stats_platinum(inputs)
	if (locale === "it") return it_profile_stats_platinum(inputs)
	if (locale === "hu") return hu_profile_stats_platinum(inputs)
	if (locale === "nl") return nl_profile_stats_platinum(inputs)
	if (locale === "no") return no_profile_stats_platinum(inputs)
	if (locale === "pl") return pl_profile_stats_platinum(inputs)
	if (locale === "pt-BR") return pt_br2_profile_stats_platinum(inputs)
	if (locale === "pt") return pt_profile_stats_platinum(inputs)
	if (locale === "ro") return ro_profile_stats_platinum(inputs)
	if (locale === "fi") return fi_profile_stats_platinum(inputs)
	if (locale === "sv") return sv_profile_stats_platinum(inputs)
	if (locale === "vi") return vi_profile_stats_platinum(inputs)
	if (locale === "tr") return tr_profile_stats_platinum(inputs)
	if (locale === "cs") return cs_profile_stats_platinum(inputs)
	if (locale === "bg") return bg_profile_stats_platinum(inputs)
	if (locale === "ru") return ru_profile_stats_platinum(inputs)
	if (locale === "uk") return uk_profile_stats_platinum(inputs)
	if (locale === "ar") return ar_profile_stats_platinum(inputs)
	if (locale === "hi") return hi_profile_stats_platinum(inputs)
	if (locale === "th") return th_profile_stats_platinum(inputs)
	if (locale === "ja") return ja_profile_stats_platinum(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_stats_platinum(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_stats_platinum(inputs)
	return ko_profile_stats_platinum(inputs)
});
export { profile_stats_platinum as "profile.stats.platinum" }